// extracted by mini-css-extract-plugin
export default {"siteStatusCardSContainer":"dashboard_siteStatusCardSContainer__AcLqj"};